import User from '@/models/User';

export default {
  user: (state) => new User(state.user),
  tempUser: (state) => new User(state.tempUser),
  displayAuthorisationResponseDialog: (state) => state.displayAuthorisationResponseDialog,
  displayDeclineInvoiceReasonDialog: (state) => state.displayDeclineInvoiceReasonDialog,
  verifier: (state) => state.verifier,
};
